import React, { Component } from 'react';
import MiniPalette from './MiniPalette';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Link } from 'react-router-dom';

import { Dialog, DialogTitle, List, ListItem, ListItemAvatar, Avatar, ListItemText } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import blue from '@material-ui/core/colors/blue';
import red from '@material-ui/core/colors/red';

import { withStyles } from '@material-ui/styles';
import styles from './styles/PaletteListStyles';

export default withStyles(styles)(
	class PaletteList extends Component {
		constructor(props) {
			super(props);
			this.state = { openDeleteDialog: false, deletingId: '' };
			this.openDialog = this.openDialog.bind(this);
			this.closeDialog = this.closeDialog.bind(this);
			this.handleDelete = this.handleDelete.bind(this);
			this.gotoPalette = this.gotoPalette.bind(this);
		}
		gotoPalette(id) {
			this.props.history.push(`/palette/${id}`);
		}
		openDialog(id) {
			this.setState({ openDeleteDialog: true, deletingId: id });
		}
		closeDialog(id) {
			this.setState({ openDeleteDialog: false, deletingId: id });
		}
		handleDelete() {
			this.props.deletePalette(this.state.deletingId);
			this.closeDialog();
		}
		render() {
			const { palettes, classes } = this.props;
			const { openDeleteDialog } = this.state;
			return (
				<div className={classes.root}>
					<div className={classes.container}>
						<nav className={classes.nav}>
							<h1 className={classes.heading}>React Colors</h1>
							<Link to="/palette/new">Create Palette</Link>
						</nav>
						<TransitionGroup className={classes.palettes}>
							{palettes.map((palette) => (
								<CSSTransition key={palette.id} classNames="fade" timeout={500}>
									<MiniPalette
										{...palette}
										gotoPalette={this.gotoPalette}
										openDialog={this.openDialog}
										key={palette.id}
										id={palette.id}
									/>
								</CSSTransition>
							))}
						</TransitionGroup>
					</div>
					<Dialog open={openDeleteDialog} aria-labelledby="delete-dialog-title" onClose={this.closeDialog}>
						<DialogTitle id="delete-dialog-title">Delete This Palette?</DialogTitle>
						<List>
							<ListItem button onClick={this.handleDelete}>
								<ListItemAvatar>
									<Avatar style={{ backgroundColor: blue[100], color: blue[600] }}>
										<CheckIcon />
									</Avatar>
								</ListItemAvatar>
								<ListItemText primary="Delete" />
							</ListItem>
							<ListItem button onClick={this.closeDialog}>
								<ListItemAvatar>
									<Avatar style={{ backgroundColor: red[100], color: red[600] }}>
										<CloseIcon />
									</Avatar>
								</ListItemAvatar>
								<ListItemText primary="Cancel" />
							</ListItem>
						</List>
					</Dialog>
				</div>
			);
		}
	}
);
